import { useState, useCallback } from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { t } from 'ttag'

import { Button } from '@h2/components/buttons/button'
import { SubmitCircleIcon } from '@h2/components/icons/submitCircle'
import { StartCircleIcon } from '@h2/components/icons/startCircle'
import { ContinueCircleIcon } from '@h2/components/icons/continueCircle'
import { PB90T, PB97T } from '@h2/components/colors'

import { Confirmation } from './confirmation'

import { Link } from '../../../link'
import { useCallbackOnRouteChange } from '../../../hooks/useCallbackOnRouteChange'

const actionStyles = css`
  && {
    color: black;
    font-size: 10px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border: 1px solid ${PB90T};
    border-radius: 4px;
    padding: 3px 6px;
    white-space: nowrap;
    width: auto;
    pointer-events: auto;
    line-height: normal;

    span[role='img'] {
      svg {
        width: 20px;
        height: 20px;
      }
    }

    &:hover {
      text-decoration: none;
      background-color: ${PB97T};
      border-color: white;
    }

    &:focus {
      text-decoration: none;
    }
  }
`
const LinkButton = styled(Link)`
  ${actionStyles};

  span[role='img'] {
    margin-left: 8px;
  }
`
const ActionButton = styled(Button)`
  ${actionStyles};
`
const getTextAndIcon = ({ isSubmitted, isStarted, pctCompleted }) => {
  if (!isStarted) {
    return [t`Start`, StartCircleIcon]
  }

  if (pctCompleted === 100 && !isSubmitted) {
    return [t`Submit`, SubmitCircleIcon]
  }

  return [t`Continue`, ContinueCircleIcon]
}
const Action = ({ lesson }) => {
  const [text, Icon] = getTextAndIcon(lesson)
  const [showConfirm, setShowConfirm] = useState(false)

  useCallbackOnRouteChange(
    useCallback(() => {
      setShowConfirm(false)
    }, [setShowConfirm])
  )

  if (Icon === SubmitCircleIcon) {
    return (
      <>
        <ActionButton
          icon={Icon}
          onClick={evt => {
            evt.stopPropagation()
            setShowConfirm(true)
          }}>
          {text}
        </ActionButton>
        {showConfirm && (
          <Confirmation
            lessonId={lesson.id}
            onClose={evt => {
              evt.stopPropagation()
              setShowConfirm(false)
            }}
          />
        )}
      </>
    )
  }

  return (
    <LinkButton href={`/planning/assignments/detail/${lesson.id}`}>
      {text}
      <Icon />
    </LinkButton>
  )
}

Action.propTypes = {
  lesson: PropTypes.object.isRequired
}

export { Action }
